module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight.b77a9847.ttf";